import _error         from "_common/error";
import {
	createAuthToken,
	storeUserDataCookie,
	USER_LOGIN_REQUEST
} from "_common/utils/user";
import XHR         from "_common/xhr";
import { configs } from "_config/index";

export const createAuthData = async function () {
	const tokenData = createAuthToken ();

	const result = await XHR.post.bind ( tokenData ) ( {
		url  : `${ configs.USER_API_URL }user-profile/deviceLogin`,
		data : USER_LOGIN_REQUEST
	} );

	return storeUserDataCookie ( { accessToken: result?.accessToken, deviceId: tokenData?.deviceId } );
};

export const loginApi = async data => {
	let loginData = {
		countryCode : data.countryCode,
		locale      : data.locale,
		mobile      : data.mobile,
		otp         : data.otp,
		otpTxnId    : data.otpTxnId.toString (),
		pushId      : data.pushId
	};

	const tokenData = createAuthToken ( loginData );

	const response = await XHR.post.bind ( tokenData ) ( {
		url     : `${ configs.USER_API_URL }user-profile/login`,
		headers : {
			"Content-Type"     : "application/json",
			thirdPartyCampaign : "{ \"campaign\": \"\", \"source\" : \"google-play\", \"medium\" : \"organic\" }"
		},
		data: loginData
	} );

	return response;
};

export const loginWithGoogleApi = async loginData => {

	const tokenData = createAuthToken ( loginData );

	const response = await XHR.post.bind ( tokenData ) ( {
		url  : `${ configs.USER_API_URL }user-profile/social`,
		data : loginData
	} );

	return response;
};

export const logoutApi = async () => {
	await XHR.post ( {
		url     : `${ configs.USER_API_URL }user-profile/logout`,
		headers : {
			"Content-Type": "application/json"
		}
	} );

	return;
};

export const getGrowthStats = async ( { userId, startDate, endDate, type } ) => {
	const res = await XHR.get ( {
		url: `${ configs.USER_API_URL }user-profile/${ userId }/${ type }?startDate=${ startDate }&endDate=${ endDate }`
	} );

	return res;
};

export const enableOtpInput = async ( mobile, countryCode ) => {
	const data = {
		countryCode,
		mobile,
		smsToken: "asdg1234567"
	};

	const tokenData = createAuthToken ( data );

	const result = await XHR.post.bind ( tokenData ) ( {
		url: `${ configs.USER_API_URL }user-profile/otp`,
		data
	} );

	if ( !result )
		return false;

	return result;
};

export const getUserProfile = async function ( userData, queryParams ) {
	if ( !userData.userId )
		return;

	const response = await XHR.get.bind ( this ) ( {
		url    : `${ configs.USER_API_URL }user-profile/${ userData.userId }`,
		params : queryParams ? queryParams: {}

	} );

	return response;
};

export const updateUserProfile = async data => {
	const { sportsFanId, userProfileDetails } = data;
	const locale                              = "en";

	userProfileDetails.contentLocale = "en";

	const response = await XHR.put ( {
		url     : `${ configs.USER_API_URL }user-profile/${ sportsFanId }`,
		headers : {
			"Content-Type": "application/json"
		},
		data: {
			...userProfileDetails,
			locale
		}
	} );

	return response;
};

export const getUserProfileStats = async function ( { userAuthDetails } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_API_URL }user-profile/${ userAuthDetails.userId }/ugcStats`
	} );

	return response;
};

export const toggleFollowUser = async ( { userId, action } ) => {
	const response = await XHR.put ( {
		url     : `${ configs.USER_API_URL }user-profile/${ userId }/${ action }`,
		headers : {
			"Content-Type": "application/json"
		}
	} );

	if ( !response || response.action.toUpperCase () !== action.toUpperCase () || response.sportsFanId.toString () !== userId.toString () )
		throw _error ( "An error occured" );

	return response;
};

export const getUserProfilesList = async profileIds => {

	let idString = "";

	for ( let i = 0; i < profileIds.length; i++ ) {

		if ( i < profileIds.length - 1 ) {
			idString += profileIds[i] + ",";
		} else {
			idString += profileIds[i];
		}
	}
	try {
		const response = await XHR.get ( {
			url    : `${ configs.USER_API_URL }user-profile/users`,
			params : {
				ids      : idString,
				ugcStats : true,
				follow   : true

			}
		} );

		return response;
	} catch ( error ) {
		return [];
	}
};

export const getUserFollowing = async ( { userId, pageNo, pageSize } ) => {
	try {
		const response = await XHR.get ( {
			url: `${ configs.USER_API_URL }user-profile/${ userId }/following?pageNo=${ pageNo }&pageSize=${ pageSize }`
		} );

		return response;
	} catch ( error ) {
		return [];
	}
};

export const getUserFollowers = async ( { userId, pageNo, pageSize } ) => {
	try {
		const response = await XHR.get ( {
			url: `${ configs.USER_API_URL }user-profile/${ userId }/followers?pageNo=${ pageNo }&pageSize=${ pageSize }`
		} );

		return response;
	} catch ( error ) {
		return [];
	}
};

export const uploadImage = async ( { formData } ) => {
	const response = await XHR.post ( {
		url     : `${ configs.FEED_POPULATOR_URL }uploadS3`,
		headers : {
			"Content-Type": "multipart/form-data"
		},
		data: formData
	} );

	return response;
};

export const getUserProfileFromBranch = async ( { url } ) => {
	const deepLinks = [ url ];

	const response = await XHR.post ( {
		url     : `${ configs.USER_API_URL }management/getDataByDeepLinks`,
		headers : {
			"Content-Type": "application/json"
		},
		data: {
			deepLinks
		}
	} );

	return response[0]?.data || {};
};

export const verifyTVCode = async ( { code } ) => {

	const response = await XHR.post ( {
		url     : `${ configs.USER_API_URL }user-profile/validateTvCode`,
		headers : {
			"Content-Type": "application/json"
		},
		data: {
			code
		}
	} );

	return response;
};

export const getForMeNotificationsFeed = async ( { SK = "", pageSize, pageNo } ) => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/for-me?SK=${ encodeURIComponent ( SK ) }&pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getActivityNotificationsFeed = async ( { SK = "", pageNo, pageSize } ) => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/activity?SK=${ encodeURIComponent ( SK ) }&pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getUpdatesNotificationsFeed = async ( { SK = "", pageNo, pageSize } ) => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/updates-all?SK=${ encodeURIComponent ( SK ) }&pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getFeaturesNotificationsFeed = async ( { SK = "", pageNo, pageSize } ) => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/updates-nf?SK=${ encodeURIComponent ( SK ) }&pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getAnnouncementsNotificationsFeed = async ( { SK = "", pageNo, pageSize } ) => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/updates-an?SK=${ encodeURIComponent ( SK ) }&pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getNotificationCount = async () => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/for-me/new-count`
	} );

	return response;
};

export const getNotificationSettings = async () => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/settings`
	} );

	return response;
};

export const updateNotificationSettings = async params => {
	const response = await XHR.post ( {
		url  : `${ configs.GROOT_URL }ntab/settings`,
		data : params
	} );

	return response;
};

export const markAllReadNotifications = async () => {
	const response = await XHR.get ( {
		url: `${ configs.GROOT_URL }ntab/tab/for-me/read`
	} );

	return response;
};

export const markSingleNotificationAsRead = async params => {
	const response = await XHR.post ( {
		url  : `${ configs.GROOT_URL }ntab/metrics`,
		data : params
	} );

	return response;
};

export const captureUserVisitingSession = async () => {
	const result = await XHR.get ( {
		url: `${ configs.USER_API_URL }user-profile/captureSession`
	},
	{
		emptyResponse: true
	} );

	return result;
};

export const getTopProfiles = async function () {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_API_URL }top-profiles?isFollowing=true&follow=true`
	} );

	return result;
};

export const getProfileHandleUsers = async function ( { pageNo = 1, pageSize = 10 } ) {

	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_API_URL }user-profile/customProfileHandleUsers?pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};
